import { format, isValid, parseISO, startOfDay } from "date-fns";

/** Preserve local calendar dates for ISO input; otherwise use native JS parsing. */
export function parseReportDate(input) {
  const text = (input || "").trim();
  if (!text) return undefined;
  if (/^\d{4}-/.test(text)) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return undefined;
    const date = parseISO(text);
    return isValid(date) && format(date, "yyyy-MM-dd") === text
      ? date
      : undefined;
  }
  const date = new Date(text);
  return isValid(date) ? startOfDay(date) : undefined;
}
